'use client';

export default function DashboardBackground() {
  return (
    <>
      {/* Purple theme background with glow - matching homepage */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-[1000px] h-[1000px] bg-purple-600/15 rounded-full blur-[140px] animate-glow-breathe" />
        <div className="absolute bottom-1/4 right-1/4 w-[800px] h-[800px] bg-blue-600/8 rounded-full blur-[120px] animate-glow-breathe-delayed" />
        <div 
          className="absolute inset-0 opacity-[0.025]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}
        />
      </div>

      {/* Add breathing animation */}
      <style jsx global>{`
        @keyframes glow-breathe {
          0%, 100% {
            opacity: 0.15;
            transform: scale(1);
          }
          50% {
            opacity: 0.20;
            transform: scale(1.05);
          }
        }

        @keyframes glow-breathe-delayed {
          0%, 100% {
            opacity: 0.08;
            transform: scale(1);
          }
          50% {
            opacity: 0.12;
            transform: scale(1.03);
          }
        }

        .animate-glow-breathe {
          animation: glow-breathe 8s ease-in-out infinite;
        }

        .animate-glow-breathe-delayed {
          animation: glow-breathe-delayed 10s ease-in-out infinite;
          animation-delay: 2s;
        }
      `}</style>
    </>
  );
}
